module.exports = __webpack_public_path__ + "assets/7538e67d5fe17875dea99bd7b14f990f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet+1.mp3
 ** module id = 232
 ** module chunks = 0
 **/